import { provideWidgetClass } from "scrivito"
import { Alignment } from "shared/lib/layout/Alignment"

export const DataLoadMoreButtonWidget = provideWidgetClass(
  "DataLoadMoreButtonWidget",
  {
    attributes: {
      alignment: ["enum", { values: Object.values(Alignment) }],
      variant: [
        "enum",
        {
          values: ["primary", "secondary"]
        }
      ],
      marginTop: "boolean",
      marginBottom: "boolean",
      title: "string"
    }
  }
)
